import LoadingWidget from '../LoadingWidget';

export default function LoadingScreen() {
  return (
    <div className="py-[40%] px-[45%]">
      <LoadingWidget></LoadingWidget>
    </div>
  );
}
